import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';
import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const Standpoint = ({ id, entity }) => {
  const standpoint = entity.toJS();
  const pretext = standpoint.field_standpoint_title[0]?.value;
  const title = standpoint.field_title[0].value;
  const link = standpoint.field_link[0]?.alias ?? standpoint.field_link[0]?.uri;
  const linkTitle = standpoint.field_link[0]?.title;

  return (
    <Container id={id} className="Paragraph Standpoint">
      <div className="row">
        <div className="Standpoint__inner col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          {pretext && <span className="Standpoint__pretext">{pretext}</span>}
          <h2 className="Standpoint__title">{title}</h2>

          {(link && linkTitle) && (
            <CoreLink
              className="Standpoint__link"
              to={link}
              target={link.options?.attributes?.target ?? '_self'}
            >
              {linkTitle}<div className="icon icon-arrow-right icon-variant-2" />
            </CoreLink>
          )}
        </div>
      </div>
    </Container>
  );
};

export default Standpoint;
